// extracted by mini-css-extract-plugin
export var dividerLine = "_7f-3";
export var itemImage = "_7f-9";
export var lightDivider = "_7f-4";
export var modalContent = "_7f-5";
export var modalContentCompact = "_7f-6";
export var productCard = "_7f-a";
export var productImage = "_7f-b";
export var productImageCompact = "_7f-7";
export var productImagePlaceholder = "_7f-c";
export var productImagePlaceholderCompact = "_7f-8";
export var progressBarBackground = "_7f-1";
export var progressBarContainer = "_7f-0";
export var progressBarFill = "_7f-2";